import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const DatasetSample = (props) => {
  //#region state
  const { formValues } = props;
  const pageState = useSelector((state) => state.createDatasetPage);
  const sampleData = pageState.formValues.DatasetSampleData;
  let columns = null;
  const { t } = useTranslation();

  //#endregion
  if (sampleData && sampleData.length > 0) {
    columns = Object.keys(sampleData[0]).map((key) => ({
      field: key,
      title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize title
      width: 150, // Explicit width for each column
    }));
  }

  useEffect(() => {
    // No need to manually call loadSampleData here
  }, [sampleData]);

  return (
    <div className="dataset-grid">
      {sampleData && sampleData.length > 0 ? (
        <Grid
          data={sampleData}
          scrollable="scrollable"
          resizable={true} // Enable column resizing
          style={{ height: "400px" }}
        >
          {columns && columns.map((col, idx) => (
            <GridColumn
              key={idx}
              field={col.field}
              title={col.title}
              width={col.width} // Set the width here
            />
          ))}
        </Grid>
      ) : (
        <p>{t("datasets.create.loading")}</p>
      )}
    </div>
  );
};

export default DatasetSample;
